@if (SimConfigurationService.settings.environmentOverlayEnabled && !!info()) {
	<div class="environment-overlay" [ngStyle]="{'background-color': color}">
		<div class="environment">{{ SimConfigurationService.settings.environmentName }}</div>
		<div class="version">{{ info()?.version }}</div>
		<div class="version">{{ window.electron ? "Electron" : "Browser" }}</div>
	</div>
}
